import { apiClient } from './apiClient';
import {
  Badge,
  CreateBadgeRequest,
  UpdateBadgeRequest,
  AssignBadgeRequest,
  RemoveBadgeRequest,
  UserBadge,
  UserBadgesResponse
} from '../types/badge';

interface ApiResponse<T> {
  result: string;
  message: string;
  data: T;
}

class BadgeService {
  private baseUrl = '/api/admin/badges';

  async createBadge(request: CreateBadgeRequest): Promise<Badge> {
    const response = await apiClient.post<ApiResponse<Badge>>(this.baseUrl, request);
    return response.data;
  }

  async updateBadge(badgeId: number, request: UpdateBadgeRequest): Promise<Badge> {
    const response = await apiClient.put<ApiResponse<Badge>>(`${this.baseUrl}/${badgeId}`, request);
    return response.data;
  }

  async getBadgeById(badgeId: number): Promise<Badge> {
    const response = await apiClient.get<ApiResponse<Badge>>(`${this.baseUrl}/${badgeId}`);
    return response.data;
  }

  async getAllBadges(): Promise<Badge[]> {
    const response = await apiClient.get<ApiResponse<Badge[]>>(this.baseUrl);
    return response.data;
  }

  async deleteBadge(badgeId: number): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${badgeId}`);
  }

  async assignBadgeToUser(request: AssignBadgeRequest): Promise<UserBadge> {
    // Ensure clean JSON payload (no undefined values)
    const payload = {
      userId: Number(request.userId),
      badgeId: Number(request.badgeId)
    };
    console.log('📤 Assigning badge:', payload);
    const response = await apiClient.post<ApiResponse<UserBadge>>(`${this.baseUrl}/assign`, payload);
    return response.data;
  }

  async removeBadgeFromUser(request: RemoveBadgeRequest): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/remove`, { data: request });
  }

  async getUserBadges(userId: number): Promise<UserBadgesResponse> {
    const response = await apiClient.get<ApiResponse<UserBadgesResponse>>(`${this.baseUrl}/users/${userId}`);
    return response.data;
  }

  async checkAndAssignBadgesForUser(userId: number): Promise<void> {
    await apiClient.post<ApiResponse<void>>(`${this.baseUrl}/check/${userId}`);
  }

  async checkAndAssignAllBadges(): Promise<void> {
    await apiClient.post<ApiResponse<void>>(`${this.baseUrl}/check-all`);
  }
}

export const badgeService = new BadgeService();


